var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"status-circle",class:{
    'status-circle--correct': _vm.isCorrect && !_vm.isDisabled,
    'status-circle--incorrect': !_vm.isCorrect && !_vm.isDisabled,
    'status-circle--disabled': _vm.isDisabled,
  },style:({ width: `${_vm.size}px`, height: `${_vm.size}px`, padding: _vm.size > 20 ? '5px' : '2px' })},[_c('Icon',{style:({ fill: _vm.color }),attrs:{"name":_vm.iconName,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }